module.exports = __webpack_public_path__ + "static/media/11_dsg.08c956a6.svg";